import { ClientCookieService } from '~/lib/services/client-cookie-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useClientCookieService = defineServiceComposable('client-cookie', () => new ClientCookieService())
